import { render, staticRenderFns } from "./ttshop_mybalance.vue?vue&type=template&id=e32807ac&scoped=true"
import script from "./ttshop_mybalance.vue?vue&type=script&lang=js"
export * from "./ttshop_mybalance.vue?vue&type=script&lang=js"
import style0 from "./ttshop_mybalance.vue?vue&type=style&index=0&id=e32807ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32807ac",
  null
  
)

export default component.exports